import { Navigate } from 'router-v6'
import type { IRoute } from 'v2/types'
import { ParamRedirect } from './param-redirect'

// [old path(s), new path]. A function target carries the URL params and the query string over;
// a plain string target drops the query.
export type Redirect = [
  string | string[],
  string | ((p: Record<string, string | undefined>) => string),
]

export const rows = (list: Redirect[]): IRoute[] =>
  list.flatMap(([from, to]) =>
    (Array.isArray(from) ? from : [from]).map((path) => ({
      title: '',
      path,
      component: typeof to === 'string' ? <Navigate to={to} replace /> : <ParamRedirect to={to} />,
      hidden: true,
    })),
  )
